import React from 'react'
import EditIcon from '@material-ui/icons/BorderColorOutlined'
import ArchiveIcon from '@material-ui/icons/ArchiveRounded'
import UnArchiveIcon from '@material-ui/icons/UnarchiveRounded'
import TruckIcon from '@material-ui/icons/LocalShippingRounded'
import DotIcon from '@material-ui/icons/LensRounded'
import { useHistory } from 'react-router-dom'
import ToolTip from '../UI/ToolTip'
import { TwoLineItem, LeftSideColor, SingleItemNormal } from '../UI/TableItem'
import { ProjectItemProps } from './Types/types'

const ProjectItem: React.FC<ProjectItemProps> = ({
  project,
  archiveProjectModalToggle,
  editProjectModalToggle,
  index,
  companyId
}) => {
  const history = useHistory()
  const color = LeftSideColor(index)
  return (
    <tr
      style={{ borderLeft: `5px solid ${color.color}` }}
      className={project.active ? 'tableRowGreen tableRowHover' : 'tableRowRed tableRowHover'}
      key={project._id}
    >
      <TwoLineItem text={project.projectName} subText={project.projectNumber} width="35" />
      <TwoLineItem
        text={project.officeAddress ? project.officeAddress : '123 Street Name'}
        subText={`${project.city}, ${project.province}`}
        width="25"
      />
      <SingleItemNormal text={project.procoreProjectId ? 'Synced' : 'Local'} width="15" />
      {project.active ? (
        <td style={{ display: 'flex', alignItems: 'center' }}>
          <DotIcon style={{ width: '0.3em', fill: 'green', marginRight: '10px' }} />
          Active
        </td>
      ) : (
        <td style={{ display: 'flex', alignItems: 'center' }}>
          <DotIcon style={{ width: '0.3em', fill: 'red', marginRight: '10px' }} />
          Archived
        </td>
      )}
      {companyId === project.companyId ? (
        <td style={{ textAlign: 'right', width: '25%' }}>
          <ToolTip title="Edit">
            <EditIcon onClick={() => editProjectModalToggle(project._id)} className="actionsIcon" />
          </ToolTip>
          <ToolTip title="Hauls">
            <TruckIcon
              className="actionsIcon"
              onClick={() => history.push(`/app/hauls/${project.projectNumber}`)}
            />
          </ToolTip>
          {project.active ? (
            <ToolTip title="Archive">
              <ArchiveIcon
                onClick={() => archiveProjectModalToggle(project._id, 'archive')}
                className="actionsIcon"
              />
            </ToolTip>
          ) : (
            <ToolTip title="Unarchive">
              <UnArchiveIcon
                onClick={() => archiveProjectModalToggle(project._id, 'unarchive')}
                className="actionsIcon"
              />
            </ToolTip>
          )}
        </td>
      ) : null}
    </tr>
  )
}

export default ProjectItem
